<template>
    <topBanner/>
    <contact/>
</template>

<script>
import topBanner from '../components/common/topBanner.vue'
import contact from '../components/contact.vue'
export default {
    components: {
        topBanner,
        contact
    },
    data(){
        return{}
    }
}
</script>